export default __webpack_public_path__ + "static/media/PitaDashboardIcon.f8402c6f.png";